import React from 'react';
import { FormattedMessage } from 'react-intl';
import './PricingSectionStyle.css';



function PricingSection() {
  const pricingPlans = [
    {
      nameId: 'pricingPlan1Name',
      price: '₪500',
      featuresIds: ['pricingPlan1Feature']
    },
    {
      nameId: 'pricingPlan2Name',
      price: '₪1200',
      featuresIds: ['pricingPlan2Feature']
    },
    {
      nameId: 'pricingPlan3Name',
      price: '₪2000',
      featuresIds: ['pricingPlan3Feature']
    }
  ];

  return (
    <div dir='auto' className="pricing-section-container" data-aos="fade-up">
      <h2><FormattedMessage id="pricingTitle" /></h2>
      <div className="pricing-cards">
        {pricingPlans.map(item => (
          <div className="pricing-card" key={item.price}>
            <h3><FormattedMessage id={item.nameId} /></h3>
            <p className="pricing-price">{item.price}</p>
            {item.featuresIds.map((fId, index) => (
              <p key={index}><FormattedMessage id={fId} /></p>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default PricingSection;
